<script lang="ts" setup>
import type {ProjectsBlock} from '~/types/legacy'
import type {WorkshopProjects} from '~/types/workshop'
import type {Populated} from '~/types/populated'

const props = defineProps<{
  data: Populated<ProjectsBlock> | Populated<WorkshopProjects>
}>()
</script>

<template>
  <Container class="screen-content flex flex-col items-center space-y-6 pb-16 pt-32 text-center lg:pt-24">
    <Heading as="h3" size="caption">{{ data.headline }}</Heading>
    <Heading as="h2" size="large" class="w-full lg:w-1/2">{{ data.title }}</Heading>

    <Paragraph class="w-full lg:w-1/2">{{ data.body }}</Paragraph>

    <Action
      v-if="'action' in data"
      :size="data.action?.size"
      :intent="data.action?.intent"
      as="link"
      :to="data.action?.href ?? undefined"
      >{{ data.action?.label }}</Action
    >
  </Container>
  <ProjectsSlider class="pb-32" :projects="data.projects || []" />
</template>
